export default __webpack_public_path__ + "static/duo-wide-1280-161aa3e335e95b8ece72b53e88f72eae.webp";